import styled from "styled-components"

export const Wrapper = styled.div`
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "1000px")};
  margin: 0 auto;
  padding: 10px 20px;
  padding-bottom: 40px;
`
